import type { Href } from 'expo-router'

import type { ICON } from '@/src/general/enums/icons'

import type { TDefaultButtonProps } from '../button/default'
import type { TMessageVariantProps } from './message-variants'

export type TMessageProps = {
  buttons?: TDefaultButtonProps[]
  onClose?: VoidFunction
  className?: string
  iconName?: ICON
  testID?: string
  link?: Href
  textClassName?: string
} & TMessageVariantProps
